import $dom from "../utils/dom";
import $storage from './storage'
import ValidateService from './validate';

import {DialogService} from 'src/link-components/dialog'
import $notice from './notice';
import {MessageService} from "./message";


import {LovService} from 'src/utils/lov';
import ObjectService from 'src/link-components/object/link-object-service';
import {AddressService} from './address';
import $filter from 'src/link-components/combine-filter'
import $mvg from 'src/link-components/mvg'
import {FileService} from "./file";
import SliderService from 'src/link-components/slider/link-slider-preview-service'
import AutoTableSetting from 'src/link-components/auto-table/setting/AutoTableSetting'
import ExportModal from 'src/link-components/export/link-export-service';
import ImportModal from 'src/link-components/import/link-import-service';
import TableColumnDialog from './table/TableFromDialog'
import UserConfig from 'src/link-components/UserConfig'
import {SystemProperty} from "../utils/system.property";
import {BatchModifyService} from "./auto-table/batch-modify";
import {SelectService} from "./select";
import {LinkSortFilterService} from "./auto-table/sort-filter/link-sort-filter-service";
import {DocumentLoginService} from "../doc-components";
import {DocAccessStatistics} from "../doc-components/statistics";
import {PinyinService} from "./pinyin/PinyinService";
import {createTreeObjectService} from "./table-expansion/tree/TreeObjectService";

export function LinkService($lv) {

	const $dialog = new DialogService($lv.Vue)
	const $msg = new MessageService($lv)
	const $rule = new ValidateService($lv)
	const $object = new ObjectService($lv.Vue)
	const $userConfig = new UserConfig($lv.Vue, $storage)
	const $tableSetting = new AutoTableSetting($lv.Vue, $userConfig)
	const $export = new ExportModal($lv.Vue)
	const $import = new ImportModal($lv.Vue)
	const $tableForm = new TableColumnDialog($lv.Vue)
	const $property = new SystemProperty($lv.Vue)
	const $lov = new LovService($lv)
	const $batchModify = new BatchModifyService($lv)
	const $file = new FileService($lv)
	const $address = new AddressService($lv)
	const $select = new SelectService($lv)
	const $sortFilterDialog = new LinkSortFilterService($lv)
	const $documentLogin = new DocumentLoginService($lv.Vue)
	// 文档访问统计模块
	const $documentAccessService = new DocAccessStatistics($lv.Vue)
	const $pinyin = new PinyinService($lv)
	const $localeInstance = new $lv.Vue({})
	const $slider = new SliderService($lv)
	const $treeObject = createTreeObjectService($lv)

	const service = {
		inner: {
			$storage,
			$dom,
			$tableSetting,
			$export,
			$import,
			$tableForm,
			$property,
			$address,
			$filter,
			$batchModify,
			$sortFilterDialog,
			$documentLogin,
			$documentAccessService,
			$pinyin,
			$t: (...args) => $localeInstance.$t(...args),
		},
		outer: {
			$notice,
			$msg,
			$lov,
			$mvg,
			$object,
			$rule,
			$file,
			$slider,
			$dialog,
			$userConfig,
			$select,
			$treeObject,
		},
	}
	Object.assign($lv, service.inner)
	Object.assign($lv.Vue.prototype, service.outer)
}
